import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';

interface Attributes {
    key: string;
    value: string;
}

export interface JSScript {
    id: string;
    name: string;
    src?: string;
    inlineSrc?: string;
    attributes?: Attributes[];
    experiences?: string[];
    defer?: boolean;
    async?: boolean;
}

@Injectable()
export class ScriptService {
    private baseUrl = '/api';
    private loadedJavascript$ = new ReplaySubject<string[]>();
    private loadedJavascript: Array<any> = [];
    private staticJavascript: JSScript[] = new Array<JSScript>();
    private dynamicJavascript: JSScript[] = new Array<JSScript>();

    constructor (protected httpClient: HttpClient) {

    }

    private headers() {
        return new HttpHeaders({
            'Authorization': `Bearer ${sessionStorage.getItem('authorizationData')}`
        })
    };

    public getAPIScripts() {
        return this.httpClient.request('GET', `${this.baseUrl}/scripts`, { headers: this.headers() });
    }

    public processRUM() {
        var timeout = 100; // 10 seconds timeout
        const poll = function () {
            const timer = setTimeout(function () {
                timeout--;
                //@ts-ignore
                if (typeof cwr !== 'undefined') {
                    clearTimeout(timer);
                    const event = new CustomEvent('RUMSCRIPT.READY', {
                        detail: {
                            title: 'RUMScriptReady',
                            message: ''
                        }
                    });
                    window.dispatchEvent(event);
                }
                else if (timeout > 0) {
                    poll();
                }
                else {
                    clearTimeout(timer);
                    console.log('Failed to load AWSRum library');
                }
            }, 100);
        };

        poll();
    }

    public processScripts(jsScripts: JSScript[]) {
        var promises = [];
        jsScripts.forEach((jsScript: JSScript) => {
            // Create Javascript
            promises.push(this.createJavaScriptElement(jsScript))
        });
        return Promise.all(promises);
    }

    /**
     *
     * @param jsScript
     * @returns
     */
    createJavaScriptElement(jsScript: JSScript): Promise<{ loaded: boolean, status: string }> {
        return new Promise((resolve, reject) => {

            if (this.loadedJavascript.indexOf(jsScript.id) !== -1) {
                resolve({ loaded: true, status: 'Already loaded' });
            } else {
                let domScript = document.createElement('script') as any;

                domScript.id = jsScript.id;
                domScript.type = 'text/javascript';

                if (jsScript.src) domScript.src = jsScript.src;
                if (jsScript.inlineSrc) domScript.innerHTML = jsScript.inlineSrc;

                // add attributes
                if (jsScript.attributes) {
                    jsScript.attributes.forEach((attribute) => {
                        domScript.setAttribute(attribute.key, attribute.value);
                    });
                }

                if (domScript.readyState) {  //IE
                    domScript.onreadystatechange = () => {
                        if (domScript.readyState === "loaded" || domScript.readyState === "complete") {
                            domScript.onreadystatechange = null;
                            resolve({ loaded: true, status: 'Loaded' });
                        }
                    };
                } else {
                    domScript.onload = () => {
                        this.loadedJavascript$.next(this.loadedJavascript);
                        resolve({ loaded: true, status: 'Loaded' });
                    };
                }

                domScript.onerror = (error: any) => resolve({ loaded: false, status: 'Loaded' });

                // add to list
                this.loadedJavascript.push(jsScript.id);
                document.body.appendChild(domScript);

            }
        });

    }


}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/script.service.ts